import React from 'react'
import Header from './ContentHeader'
import ContentDetail from './ContentDetail'
import Footer from './ContentFooter'

const MainContent = ({ reservationItems, activeItem }) => {
    const reservationContent = reservationItems.filter(item => {
        return item.id === activeItem
    })
    return (
        <>
            <Header reservationContent={reservationContent} activeItem={activeItem} />
            <ContentDetail reservationContent={reservationContent} />
            <Footer reservationContent={reservationContent} />
        </>
    )
}

export default MainContent
